import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'letter-x-small', 'LetterXSmall', [["path",{"d":"M10 8l4 8","key":"svg-0"}],["path",{"d":"M10 16l4 -8","key":"svg-1"}]]);